import {extendTheme} from '@chakra-ui/react';

import {linxTheme} from './overrides';

export {useAutoSizeTextareaStyleConfig} from './components/AutoResizeTextarea';
export {useAvatarSelectStyleConfig} from './components/AvatarSelect';
export {useButtonStyleConfig} from './components/Button/Button';
export {useIconButtonStyleConfig} from './components/Button/IconButton';
export {useCardStyleConfig} from './components/Card';
export {useChartTooltipStyleConfig} from './components/ChartTooltip';
export {useContextMenuStyleConfig} from './components/ContextMenu';
export {useDatePickerStyleConfig} from './components/DatePicker';
export type {DatePickerSizes} from './components/DatePicker';
export {useDrawerStyleConfig} from './components/Drawer';
export {useEditableFieldsStyleConfig} from './components/EditableFields';
export {useEditableFormControlStyleConfig} from './components/EditableFormControl';
export {useFormSectionStyleConfig} from './components/FormSection';
export {inputTheme} from './components/Input';
export {useModalStyleConfig} from './components/Modal';
export {useNavbarStyleConfig} from './components/Navbar';
export {usePaginationStyleConfig, usePaginationThemeStyleConfig} from './components/Pagination';
export {useRadioButtonGroupStyleConfig} from './components/RadioButtonGroup/RadioButtonGroup';
export {useSelectStyleConfig} from './components/Select';
export {useStatStyle} from './components/Stat';
export {useStepperStyleConfig} from './components/Stepper';
export {useSwitchStyleConfig} from './components/Switch';
export {useTableStyleConfig} from './components/Table';
export {useTabsStyleConfig} from './components/Tabs';
export {useToastStyleConfig} from './components/Toast';

export * from './components/TableFilters';
export * from './utils';

export {getScheme, intents, isIntent} from './intent';
export type {Intent} from './intent';
export {coreTokens, linxTheme as overrides} from './overrides';
export {getCoreValueAsThemeToken} from './types';

export const theme = linxTheme;
export const themeWithChakra = extendTheme(linxTheme);
